import { useExportAction } from "@/action/use-export-action";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { kitLabel } from "@/lib/kit-label";
import { Kit } from "@/types/types";
import { KitQuickSettingsUI } from "./KitQuickSettingsUI";

type ConversationKitQuickSettingsProps = {
  kit: Kit;
};

export const ConversationKitQuickSettings = ({
  kit,
}: ConversationKitQuickSettingsProps) => {
  const groupUuid = useGroupUuid();
  const { updateKit } = useKitData(groupUuid, kit.uuid);
  const { exportKitBundle } = useExportAction();

  return (
    <KitQuickSettingsUI
      kit={kit}
      onNameChange={(name) => updateKit({ name })}
      onExport={() =>
        exportKitBundle(
          `${kitLabel(kit)} - ${kit.name}`,
          { format: "docx", includeFiles: true },
          kit.uuid,
        )
      }
    />
  );
};
